var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollapseUp = function SvgCollapseUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "collapse-up_svg__Light",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".collapse-up_svg__collapse-icon{fill:none;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.535 18.373 12.409 5.8a.5.5 0 0 0-.749 0L.535 18.373",
    className: "collapse-up_svg__collapse-icon"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.535 18.373 12.409 5.8a.5.5 0 0 0-.749 0L.535 18.373",
    className: "collapse-up_svg__collapse-icon"
  })));
};
export default SvgCollapseUp;